import { render, staticRenderFns } from "./KnFieldSelect.vue?vue&type=template&id=2c0051d2"
import script from "./KnFieldSelect.vue?vue&type=script&lang=js"
export * from "./KnFieldSelect.vue?vue&type=script&lang=js"
import style0 from "./KnFieldSelect.vue?vue&type=style&index=0&id=2c0051d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports